export interface AdminUser {
  id: string;
  email: string;
  plan: 'starter' | 'founder' | 'scale';
  generations_used: number;
  generations_limit: number;
  period_start: string;
  locale: string;
  role: 'user' | 'admin';
  created_at: string;
  updated_at: string;
}

export async function fetchAdminUsers(): Promise<AdminUser[]> {
  const response = await fetch('/api/auth/admin/users', {
    credentials: 'same-origin',
  });
  const data = (await response.json()) as { users?: AdminUser[]; error?: string };
  if (!response.ok) {
    throw new Error(data.error || `Request failed: ${response.status}`);
  }
  return data.users || [];
}

export async function updateAdminUser(payload: {
  id: string;
  plan?: AdminUser['plan'];
  role?: AdminUser['role'];
  generations_used?: number;
  generations_limit?: number;
}): Promise<AdminUser> {
  const response = await fetch('/api/auth/admin/update', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(payload),
  });
  const data = (await response.json()) as { user?: AdminUser; error?: string };
  if (!response.ok) {
    throw new Error(data.error || `Request failed: ${response.status}`);
  }
  if (!data.user) throw new Error('No user returned');
  return data.user;
}

export async function deleteAdminUser(id: string): Promise<void> {
  const response = await fetch('/api/auth/admin/delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ id }),
  });
  const data = (await response.json()) as { error?: string };
  if (!response.ok) {
    throw new Error(data.error || `Request failed: ${response.status}`);
  }
}
